import {SpanIcon} from '@mazraeapp/react_icon_kit';
import classNames from 'classnames';
import React, {useEffect, useRef} from 'react';
import {IChoosed} from '..';
import CountDown from '../../advertismentDetail/countDown';
import {useLocation, useNavigate} from 'react-router-dom';

interface SlideItemProps {
  id: string;
  planGuid: string;
  packageName: string;
  packageImage: string;
  packagePrice: number;
  description: string;
  stepChoosed?: string;
  discountPrice: number | null;
  elements: Array<GetStorePlansDataPlanInfoPlansAccess>;
  choosed?: IChoosed;
  discount_amount: number;
  user_active_plan: GetStorePlansDataUserActivePlan | null;
  is_active_discount: boolean;
  plan_type: string;
  setStepChoosed: React.Dispatch<React.SetStateAction<string | undefined>>;
  setchoosed: React.Dispatch<React.SetStateAction<IChoosed | undefined>>;
}
const SlideItem = ({
  id,
  packageImage,
  packageName,
  packagePrice,
  description,
  discountPrice,
  is_active_discount,
  discount_amount,
  elements,
  plan_type,
  planGuid,
  user_active_plan,
  setStepChoosed,
  setchoosed,
}: SlideItemProps) => {
  const navigate = useNavigate();
  const {state} = useLocation();
  const scrollTargetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (state?.package_type === id) {
      scrollTargetRef.current?.scrollIntoView({behavior: 'smooth'});
    }
  }, [navigate, state?.package_type, id]);
  return (
    <div
      ref={scrollTargetRef}
      id={id}
      className="flex snap-center flex-col border-[1px] border-green-200 max-w-[280px] min-w-[280px] h-fit gap-2  shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.6)] rounded-[8px] py-4"
    >
      <h4 className="w-full text-center font-Medium text-[24px] text-red-950 flex items-center justify-center gap-2">
        {packageName}
        {is_active_discount && (
          <span className="text-white rounded-md text-[8px] font-600 px-1 py-1 bg-red-500 w-fit h-fit">
            %{discount_amount}
          </span>
        )}
      </h4>
      <div className="w-full flex justify-center">
        <img width={216} height={166} src={packageImage} alt={packageName} />
      </div>
      <div className="flex w-full flex-col">
        <p className="w-full text-center gap-1 justify-center flex items-center text-red-800 text-[32px] font-Bold">
          <span>
            {discountPrice !== null && discountPrice !== undefined
              ? (discountPrice / 10).toLocaleString()
              : (packagePrice / 10).toLocaleString()}
          </span>
          <span className="font-Medium text-sm">تومان</span>
        </p>
        {discountPrice !== null &&
          discountPrice !== undefined &&
          discountPrice !== 0 && (
            <p className="text-center text-gray-500 text-xl font-DemiBold line-through">
              {(packagePrice / 10).toLocaleString()}
            </p>
          )}
      </div>

      <p className="w-full leading-[24px] px-4 text-gray-900 text-md font-Regular text-justify">
        {description}
      </p>
      <div className="w-full flex justify-center">
        <div className="w-[90%] h-[1px] flex border-[1px] border-t-gray-200  border-dashed"></div>
      </div>
      <div className="w-full py-3 flex gap-3 justify-center flex-col items-center">
        {user_active_plan &&
          plan_type !== 'free' &&
          user_active_plan.plan_type === plan_type &&
          user_active_plan?.expire_time && (
            <CountDown isMonth={true} dateTime={user_active_plan.expire_time} />
          )}

        {user_active_plan && user_active_plan.plan_type === plan_type ? (
          <button className="font-Medium text-sm rounded-[8px] h-[40px] text-white w-[232px] justify-center gap-2 bg-green-500 flex items-center">
            <SpanIcon className="icon-nameCheckmark text-[20px]" />
            <span>پکیج فعال من</span>
          </button>
        ) : (
          <>
            {user_active_plan &&
            plan_type === 'free' &&
            user_active_plan.plan_type !== 'free' ? (
              <div className="font-Medium text-sm rounded-[8px] h-[40px] text-gray-600 w-[232px] justify-center gap-2 bg-gray-200 flex items-center">
                <span>فعال سازی</span>
              </div>
            ) : (
              <button
                className="font-Medium text-sm rounded-[8px] h-[40px] text-white w-[232px] bg-red-800"
                onClick={() => {
                  setStepChoosed('stepOne');
                  setchoosed({
                    guid: planGuid,
                    price: packagePrice,
                    discountPrice: discountPrice,
                    discount_amount: discount_amount,
                  });
                }}
              >
                شروع ارتقا فروشگاه
              </button>
            )}
          </>
        )}
      </div>
      {elements && elements?.length !== 0 && (
        <div className="flex flex-col w-full gap-3">
          <h5 className="w-full text-center text-sm font-DemiBold text-gray-800">
            ویژگی های  {packageName}
          </h5>
          {elements?.map((item, index) => (
            <div className="flex flex-col px-2  w-full" key={index}>
              <div className="flex w-ful gap-2 items-start py-[1px]">
                <SpanIcon
                  className={classNames({
                    'icon-nameCheckmark text-gray-900 text-[20px]': item.status,
                    'icon-nameClose-remove text-red-800 text-[20px]':
                      !item.status,
                  })}
                />
                <p className="p-0 m-0 text-gray-900 text-sm font-Regular">
                  {item.title}
                </p>
              </div>
              <div className="w-full flex justify-center">
                <div className="w-full h-[1px] flex border-[0.5px] border-t-gray-100  "></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SlideItem;
